import { Table } from 'semantic-ui-react';
import React from 'react';
import SettlementCommon from 'components/SettlementList/SettlementCommon';

const TaxInvoiceTable = ({ descr }) => {
  return (
    <Table singleLine celled>
      <Table.Body>
        <Table.Row>
          <Table.Cell colSpan={10} className="title">
            {descr.title}
          </Table.Cell>
        </Table.Row>
        <Table.Row className="thead">
          <Table.Cell className="title" colSpan={5}>
            전자세금계산서
          </Table.Cell>
          <Table.Cell className="ntsKey" colSpan={2}>
            승인번호
          </Table.Cell>
          <Table.Cell className="ntsKey" colSpan={3}>
            {descr.ntsSendKey ? descr.ntsSendKey : '-'}
          </Table.Cell>
        </Table.Row>
        <Table.Row className="thead">
          <Table.Cell rowSpan={8}>
            공<br />급<br />자
          </Table.Cell>
          <Table.Cell>등록번호</Table.Cell>
          <Table.Cell className="value bold" width={3}>
            {SettlementCommon.bizSerialFormatter(descr.providerBizSerial)}
          </Table.Cell>
          <Table.Cell>종사업장</Table.Cell>
          <Table.Cell className="value" width={3}>
            {descr.providerBizSubSerial}
          </Table.Cell>

          <Table.Cell rowSpan={8}>
            공<br />급<br />받<br />는<br />자
          </Table.Cell>
          <Table.Cell>등록번호</Table.Cell>
          <Table.Cell className="value bold" width={3}>
            {SettlementCommon.bizSerialFormatter(descr.receiverBizSerial)}
          </Table.Cell>
          <Table.Cell>종사업장</Table.Cell>
          <Table.Cell className="value" width={3}>
            {descr.receiverBizSubSerial}
          </Table.Cell>
        </Table.Row>
        <Table.Row className="thead first">
          <Table.Cell>
            상호
            <br />
            (법인명)
          </Table.Cell>
          <Table.Cell className="value">{descr.providerBizName}</Table.Cell>
          <Table.Cell>성명</Table.Cell>
          <Table.Cell className="value">{descr.providerChargeName}</Table.Cell>
          <Table.Cell>
            상호
            <br />
            (법인명)
          </Table.Cell>
          <Table.Cell className="value">{descr.receiverBizName}</Table.Cell>
          <Table.Cell>성명</Table.Cell>
          <Table.Cell className="value">{descr.receiverChargeName}</Table.Cell>
        </Table.Row>
        <Table.Row className="thead first">
          <Table.Cell>
            사업장
            <br />
            주소
          </Table.Cell>
          <Table.Cell className="value" colSpan={3}>
            {descr.providerAddress}
          </Table.Cell>

          <Table.Cell>
            사업장
            <br />
            주소
          </Table.Cell>
          <Table.Cell className="value" colSpan={3}>
            {descr.receiverAddress}
          </Table.Cell>
        </Table.Row>
        <Table.Row className="thead first">
          <Table.Cell>업태</Table.Cell>
          <Table.Cell className="value">{descr.providerBizCondition}</Table.Cell>
          <Table.Cell>종목</Table.Cell>
          <Table.Cell className="value">{descr.providerBizType}</Table.Cell>

          <Table.Cell>업태</Table.Cell>
          <Table.Cell className="value">{descr.receiverBizCondition}</Table.Cell>
          <Table.Cell>종목</Table.Cell>
          <Table.Cell className="value">{descr.receiverBizType}</Table.Cell>
        </Table.Row>
        <Table.Row className="thead">
          <Table.Cell className="firstTd" rowSpan={2}>
            이메일
          </Table.Cell>
          <Table.Cell className="value" colSpan={3} rowSpan={2}>
            {descr.providerEmail}
          </Table.Cell>
          <Table.Cell>이메일</Table.Cell>
          <Table.Cell className="value" colSpan={3}>
            {descr.receiverEmail1}
          </Table.Cell>
        </Table.Row>
        <Table.Row className="thead first">
          <Table.Cell>이메일</Table.Cell>
          <Table.Cell className="value" colSpan={3}>
            {descr.receiverEmail2}
          </Table.Cell>
        </Table.Row>
      </Table.Body>
    </Table>
  );
};

export { TaxInvoiceTable };
